// Quotation utility functions

export const generateQuotationNumber = (quoteNumber: number): string => {
  const paddedNumber = String(quoteNumber).padStart(4, '0');
  const year = new Date().getFullYear();
  return `QT/${paddedNumber}/${year}`;
};

export const getNextQuotationNumber = (existingQuotes: any[]): number => {
  if (existingQuotes.length === 0) {
    return 1;
  }
  
  // Extract the last number from the last quote number
  const lastQuote = existingQuotes[existingQuotes.length - 1];
  const lastNo = lastQuote.no;
  
  // Parse the number from QT/XXXX/YYYY format
  const lastNumber = parseInt(lastNo.split('/')[1]);
  return lastNumber + 1;
};
